import { Grid, Select, Textarea, TextInput, Text, Checkbox, Radio, RadioGroup, Autocomplete } from '@mantine/core';
import React from 'react';
import { DateInput } from '@mantine/dates';
import { useMediaQuery } from '@mantine/hooks';

const SalesHeaderTable = ({ inputFields, swatchData }) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  return (
    <div style={{ padding: '10px' }}>
      <Grid gutter="xl">
        {inputFields?.map((field, index) => (
          <Grid.Col key={index} span={isMobile ? 12 : field.span || 2}>
            <div>
              <div style={{ marginBottom: 5 }}>
                <Text size="sm" weight={500} c="gray.6">
                  {field.label}
                  {field.require && <span className="error-message"> *</span>}
                </Text>
              </div>

              {field.type === 'TextInput' && (
                <TextInput
                  name={field.name}
                  {...(field.value !== 'N/A' && { title: field.value })}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  readOnly={field.readOnly}
                  disabled={field.disabled}
                  variant="unstyled"
                  styles={{
                    input: {
                      borderBottom: '2px solid lightgray',
                      textDecoration: 'none',
                      fontWeight: 550,
                      fontSize: '12px'
                    },
                  }}
                  required={field?.required}
                />
              )}

              {field.type === 'B2BSelect' && (
                <Select
                  name={field.name}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  data={field.data}
                  disabled={field.disabled}
                  readOnly={field.readOnly}
                  key={field?.value}
                  clearable={field?.clearable}
                  searchable={field?.searchable}
                  onOptionSubmit={field?.onOptionSubmit}
                  variant="Default"
                  styles={{
                    input: {
                      borderBottom: '2px solid lightgray',
                      textDecoration: 'none',
                      backgroundColor: 'lightgray',
                      fontWeight: 550,
                      fontSize: '12px'
                    },
                  }}
                />
              )}

              {field.type === 'Autocomplete' && (
                <Autocomplete
                  name={field.name}
                  placeholder={field.placeholder || 'Search Vendor'}
                  value={field.value}
                  onChange={field.onChange}
                  onOptionSubmit={field.onOptionSubmit}
                  data={field.data}
                  disabled={field.disabled}
                  readOnly={field.readOnly}
                  variant="unstyled"
                  styles={{
                    input: {
                      borderBottom: '2px solid lightgray',
                      textDecoration: 'none',
                      fontWeight: 550,
                      fontSize: '12px'
                    },
                  }}
                  required={field?.require}
                  clearable={field?.clearable}
                />
              )}

              {field.type === 'Textarea' && (
                <Textarea
                  label={field.label}
                  name={field.name}
                  placeholder={field.placeholder}
                  value={field.value}
                  readOnly={field.readOnly}
                  className={field.className}
                  withAsterisk={field.required}
                  variant="filled"
                />
              )}

              {field.type === 'DateInput' && (
                <DateInput
                  name={field.name}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  disabled={field.disabled}
                  readOnly={field.readOnly}
                  variant="unstyled"
                  styles={{
                    input: {
                      borderBottom: '2px solid lightgray',
                      textDecoration: 'none',
                      fontWeight: 550,
                      fontSize: '12px'
                    },
                  }}
                />
              )}

              {field.type === 'checkbox' && (
                <Checkbox
                  name={field.name}
                  label={field.label}
                  checked={field.value}
                  onChange={(event) => field.onChange(event.currentTarget.checked)}
                  readOnly={field.readOnly}
                  disabled={field.disabled}
                  styles={{
                    label: {
                      fontWeight: 550,
                      fontSize: '12px',
                    },
                    input: {
                      borderColor: 'lightgray',
                      cursor: field.disabled ? 'not-allowed' : 'pointer',
                    },
                  }}
                />
              )}

              {field.fieldType === "radioField" && (
                <div className="radio-group" style={{ justifyContent: 'normal' }}>
                  {field?.roll && (
                    <>
                      <input
                        type="radio"
                        value={field?.roll?.value}
                        name={field?.roll?.name}
                        checked={true}
                        disabled={field?.roll?.disabled}
                      />
                      <label className='radio-label'>{field?.roll?.label}</label>
                    </>
                  )}
                  {field.options.map((option, idx) => (
                    <div key={idx} className="radio-item" style={{ display: "flex", gap: '0.5rem' }}>
                      <input
                        type="radio"
                        value={option?.value}
                        name={field.name}
                        onChange={field?.onChange}
                        disabled={field.disabled}
                        onClick={option?.onChange}
                        checked={field.uomchecked ? field.uomchecked(option) : field.value === option.value}
                      />
                      <label className='radio-label'>{option.label}</label>
                    </div>
                  ))}
                  {field?.error && (
                    <span className='error-message'>
                      {field?.error}
                    </span>
                  )}
                </div>
              )}
              {field.type === 'Select' && (
                <Select
                  name={field.name}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  data={field.data}
                  clearable={field.clearable}
                  disabled={field.disabled}
                  readOnly={field.readOnly}
                  styles={{
                    input: {
                      borderBottom: '2px solid lightgray',
                      fontWeight: 550,
                      backgroundColor: 'lightgray',
                      fontSize: '12px',
                    },
                  }}
                />
              )}

            </div>
          </Grid.Col>
        ))}
      </Grid>

    </div>
  );
};

export default SalesHeaderTable;